/* eslint-disable no-unused-vars,no-shadow */
/* global G */
import { curry, getFirstItem } from 'lib/util'
import {
  back,
  bulk,
  persistChange,
  persistCheck,
  persistOption,
  persistScroll,
  submit,
} from '@app/_shared/events'
import { jump as jumpBack, list as listBreadcrumbs } from 'app/_shared/events/breadcrumbs'
import persistOptions from '@app/_shared/events/persist/options'
import list, { refList } from '@app/_shared/events/list'
import selectAndAction from '@app/_shared/events/combined/selectAndAction'
import resetAndAction from '@app/_shared/events/combined/resetAndAction'
import search from '@app/_shared/events/search'
import createRedirect from 'app/_shared/events/appbar/createRedirect'
import detail from 'app/_shared/events/action/detail'
import redirect from '@app/_shared/events/redirect'
import link from '@app/_shared/events/link'
import listTicketTypes from 'app/_shared/events/collection/listTicketTypes'
import listInvitationRoles from 'app/_shared/events/collection/listInvitationRoles'
import listTicketStatus from 'app/_shared/events/collection/listTicketStatus'
import listStatusReasons from 'app/_shared/events/collection/listStatusReasons'
import menu from 'app/_shared/events/contextmenu'
import { document, item, reference, user } from 'app/_shared/events/pubsub'
import { model, acl, permission, cell } from 'app/_shared/events/acl'
import persistStore from 'app/_shared/events/combined/persistStore'
import searchUnsortedAndRecreate from 'app/_shared/events/appbar/searchUnsortedAndRecreate'
import setInviteeRole from 'app/_shared/events/invite/setRole'
import chain from 'app/_shared/events/util/chain'
import searchWith from 'app/_shared/events/search/with'
import setCountedLabel from 'app/_shared/events/tabs/setCountedLabel'
import toRef from 'app/_shared/events/link/toRef'
import listInvitationActions from 'app/_shared/events/collection/listInvitationActions'
import listInvitationStatuses from 'app/_shared/events/collection/listInvitationStatuses'
import infinite from 'app/_shared/events/search/infinite'
import session from 'app/_shared/session'
import listOrganisationTypes from 'app/_shared/events/collection/listOrganisationTypes'
import listStatus from 'app/_shared/events/collection/listStatus'
import persistOptionsAndAction from 'app/_shared/events/combined/persistOptionsAndAction'
import persistCheckAndAction from 'app/_shared/events/combined/persistCheckAndAction'
import hasMultipleFilters from 'app/_shared/events/search/query/hasMultipleFilters'
import persistTab from 'app/_shared/events/tabs/persist'
import remember from 'app/_shared/events/remember'
import action from 'app/_shared/events/action'
import listRequestStatus from 'app/_shared/events/collection/listRequestStatus'
import setListDrawerTitle from 'app/_shared/events/tabs/setListDrawerTitle'
import searchRequesterTickets from 'app/person/event/searchRequesterTickets'
import redirectWithContact from 'app/person/event/redirectWithContact'
import infinitePersonsWithUsers from 'app/person/event/infinitePersonsWithUsers'
import getInviteStatus from 'app/person/event/getInviteStatus'
import detailWithCount from 'app/person/event/detailWithCount'
import getValidationStatus from 'app/person/event/getValidationStatus'
import redirectToPersonOrUser from 'app/person/event/redirectToPersonOrUser'
// TODO: move to _shared:
import destroyPersonIfNoSubItems from 'app/admin/event/destroyPersonIfNoSubItems'
import { platform } from 'app/_shared/events/util'
import update from 'app/_shared/events/util/update'
import updateRequestList from 'app/request/event/updateRequestList'
import updateUnreadMessagesCount from 'app/ticket/event/updateUnreadMessagesCount'
import { countWithFilter } from 'app/_shared/events/pubsub/countWith'
import { closeModalWith } from 'app/_shared/events/modal/close'
import { toggleFavoriteFromModel } from 'app/_shared/events/favorite/toggle'
import { submitModalWith } from 'app/_shared/events/modal/submit'
import { confirm, deconfirm, jump, next, previous } from 'app/_shared/events/step'
import modelSet from 'app/_shared/events/model/set'
import modelSave from 'app/_shared/events/model/save'
import modelStateSave from 'app/_shared/events/model/stateSave'
import setStepTab, { CONFIRM, SEARCH } from 'app/_shared/events/setStepTab'
import searchStepAndRecreate from 'app/_shared/events/searchStepAndRecreate'
import displayState from 'app/_shared/events/address/displayState'
import displayHouseNumber from 'app/_shared/events/address/displayHouseNumber'
import listCountries from 'app/_shared/events/collection/listCountries'
import listUserCountries from 'app/_shared/events/collection/listUserCountries'
import check from 'app/_shared/events/util/check'
import modelReset from 'app/_shared/events/model/reset'
import resetActionComponent from 'app/_shared/events/resetActionComponent'
import find from 'lib/sequence/component/children/find'
import { reset } from 'lib/sequence/component/state/value'
import prefillSupportedBy from 'app/_shared/events/prefillSupportedBy'
import supportedBy from 'app/organisation/event/dialog/supportedBy'
import { hide, show } from 'lib/sequence/component/state/hidden'
import sublist from 'app/_shared/events/util/sublist'
import focusNext from 'app/_shared/events/field/focusNext'

export default {
  acl: {
    model,
    component: acl,
    permission,
    acl,
    cell,
  },
  onOpen: {
    listing: list('short'),
    listWithRefs: list(null),
    listVerbose: list('verbose'),
    infiniteVerbose: infinite('verbose'),
    refListWithCount: refList('defaultWithRequestCount'),
    infinitePersonsWithFilter: chain(
      searchWith(['filter']),
      infinitePersonsWithUsers,
    ),
    infiniteWithFilter: chain(
      searchWith(['filter']),
      infinite(null),
    ),
    infiniteWithCountWithFilter: chain(
      searchWith(['filter']),
      infinite('defaultWithRequestCount'),
    ),
    infiniteVerboseWithFilter: chain(
      searchWith(['filter']),
      infinite('verbose'),
    ),
    infiniteVerboseIfTerm: chain(
      curry((module, component, event) => {
        if (!component[G.STATE]?.[G.META]?.term) {
          throw Error('No term')
        }
      }),
      infinite('verbose'),
    ),
    search: search(null),
    searchWithFilter: chain(
      searchWith(['filter']),
      search(null),
    ),
    searchVerbose: search('verbose'),
    searchIfTerm: chain(
      curry((module, component, event) => {
        if (!component[G.STATE]?.[G.META]?.term) {
          throw Error('No term')
        }
      }),
      search(null),
    ),
    link,
    toOrganisation: toRef('organisation'),
    reference,
    searchRequesterTickets: searchRequesterTickets(null),
    searchRequesterAllTickets: searchRequesterTickets('verbose'),
    getInviteStatus,
    setTabSearch: searchWith(['filter']),
    setTabSearchAndListDrawerTitle: chain(
      searchWith(['filter']),
      setListDrawerTitle,
    ),
    getValidationStatus,
    listStatus,
    listBreadcrumbs,
    listCountries,
    getValues: curry(async (module, component, event, values) => values || []),
  },
  onShowAll: {
    infinite: infinite('verbose'),
    infiniteWithFilter: chain(
      searchWith(['filter']),
      infinite(null),
    ),
    infiniteVerboseWithFilter: chain(
      searchWith(['filter']),
      infinite('verbose'),
    ),
    infiniteWithCountWithFilter: chain(
      searchWith(['filter']),
      infinite('defaultWithRequestCount'),
    ),
  },
  list: {
    sub: user,
  },
  item: {
    sub: item,
  },
  cell: {
    sub: updateUnreadMessagesCount,
  },
  onSubscription: {
    submitter: curry((module, component, event) => {
      const user = getFirstItem(module[G.MODEL][G.CACHE].refs?.[component[G.PROPS].ref])
      return user?.key || user
    }),
  },
  onPublication: {
    document,
    updateRequestList,
    countWithFilter,
  },
  onSubmit: {
    focusNext: focusNext(null),
  },
  onClose: {
    redirect,
    back,
    resetFavorite: closeModalWith('favoriteModal'),
  },
  onSearch: {
    searchUnsortedAndRecreate,
    searchStepAndRecreate,
  },
  onCreate: {
    createRedirect,
  },
  onBack: {
    previous,
  },
  onClick: {
    toggleFavorite: toggleFavoriteFromModel,
    favorite: submitModalWith('submitFavorite'),
    redirect,
    redirectToPersonOrUser,
    redirectToRequestWith: redirect,
    redirectToTicketWith: redirectWithContact,
    detail,
    detailWithCount,
    reset: resetAndAction,
    back,
    submit,
    setRoleAndSubmit: chain(
      setInviteeRole(null, 'customer'),
      submit,
    ),
    redirectWithContact,
    destroyIfNoSubItems: destroyPersonIfNoSubItems,
    jumpBack,
    jump,
    next,
    setOrganisation: chain(
      modelSet('organisation'),
      modelStateSave('organisation'),
      setStepTab(CONFIRM),
      platform({ mobile: chain(
        confirm,
        next,
      ) }),
    ),
    addOrganisation: chain(
      modelSave('organisation', false),
      check,
      back,
      deconfirm,
      setStepTab(CONFIRM),
    ),
    unsetOrganisation: chain(
      modelReset('organisation'),
      resetActionComponent('organisation'),
      curry((module, component, event) => {
        const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
        const { organisation: organisationStep } = find(actionComponent)
        const { search: searchTab } = find(organisationStep)
        const { searchField } = find(searchTab)

        reset(searchField)
      }),
      setStepTab(SEARCH),
    ),
    confirmStep: chain(
      confirm,
      next,
    ),
    bulk: chain(
      action, // needed to update last step's visited state
      bulk,
    ),
  },
  onChange: {
    persistChange,
    persistCheckAndAction,
    persistOption,
    persistOptions,
    persistOptionsAndAction,
    selectAndAction,
    persistStore,
    persistInvite: chain(
      persistCheck,
      curry(async (module, component, event) => {
        console.log(event.detail.checked)
        const { inviteForm } = find(module[G.STATE][G.ACTION][G.COMPONENT])

        event.detail.checked
          ? show(inviteForm)
          : hide(inviteForm)

        await module[G.ADAPTER][G.UI].update(module)
      }),
    ),
    persistTabAndRemember: chain(
      persistTab,
      remember,
      platform({
        mobile: update,
      }),
    ),
    persistOptionsRememberAndAction: chain(
      persistOptions,
      remember,
      action,
    ),
    persistCheckRememberAndAction: chain(
      persistCheck,
      remember,
      action,
    ),
    persistCountry: curry(async (module, component, componentInfo, attributeInfo, event) => await chain(
      persistOptions,
      prefillSupportedBy,
      displayState('state', 'country', componentInfo, attributeInfo),
      displayHouseNumber('number', 'street', componentInfo, attributeInfo),
      update,
    )(module, component, event)),
    fillSupportedByAndPersistChange: chain(
      persistChange,
      prefillSupportedBy,
    ),
  },
  onContextMenu: {
    menu: menu(null),
  },
  onPage: {
    remember,
  },
  onScroll: {
    persistScrollAndRemember: chain(
      persistScroll,
      remember,
    ),
    remember,
  },
  onAction: {
    redirect,
  },
  getTicketType: {
    listTicketTypes,
  },
  getOrganisationType: {
    listOrganisationTypes,
  },
  getStatus: {
    listTicketStatus,
    listInvitationStatuses,
    listRequestStatus,
  },
  getStatusReason: {
    listStatusReasons,
  },
  getSelection: {
    listUserCountries,
    listInvitationRoles,
    listInvitationActions,
    listOrganisationTypes: curry(async (module, component, event) => sublist(
      ['customer', 'independent_contractor', 'internal', 'partner'],
      listOrganisationTypes,
    )(module, component, event).map((type) => {
      delete type.icon
      return type
    })),
  },
  getLabel: {
    setReqLabel: setCountedLabel({ ns: 'ticket', key: 'requests' }),
    setCsmLabel: setCountedLabel({ ns: 'ticket', key: 'tickets' }),
    listOrganisationTypes,
  },
  dialog: {
    supportedBy,
  },
  filter: {
    requesterContact: curry((module, component, event) => ({
      requesterContact: module[G.MODEL][G.STATE][G.REF],
    })),
    notMyselfInReq: curry((module, component, event) => {
      const context = module[G.ADAPTER][G.SESSION][G.STATE][G.CONTEXT]
      return { ...context === 'req' && { id: `!${session(module).person.key()}` } }
    }),
    isActive: curry((module, component, event) => ({
      status: { max: 79 },
    })),
    hasSubmitterAndIsOpen: curry((module, component, event) => ({
      submitter: getFirstItem(module[G.MODEL][G.CACHE]?.refs?.user),
      status: { max: 79 },
    })),
    hasSubmitterAndIsSolved: curry((module, component, event) => ({
      submitter: getFirstItem(module[G.MODEL][G.CACHE]?.refs?.user),
      status: { min: 80 },
    })),
  },
  query: {
    personHasStatusAndToBeValidated: hasMultipleFilters('person', ['status', 'toBeValidated']),
  },
}
